export default __webpack_public_path__ + "static/media/Asia.28927b25.svg";